/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GeneratedNotePagedList } from '../../models/generated-note-paged-list';
import { GeneratedNoteSearch } from '../../models/generated-note-search';
import { SortDirection } from '../../models/sort-direction';

export interface PersonalSearchGeneratedNotes$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * Indicates the field to use for sorting the data:
 *   * NAME : the notification's name
 *   * DATE : Date of the note creation
 *   * CATEGORY : Category of the note
 */
  sortFieldName?: 'NAME' | 'DATE' | 'CATEGORY';

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;

/**
 * The search text to filter API
 */
  search?: string;
  
    /**
     * Body for search gene note
     */
    body?: GeneratedNoteSearch
}

export function personalSearchGeneratedNotes(http: HttpClient, rootUrl: string, params?: PersonalSearchGeneratedNotes$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneratedNotePagedList>> {
  const rb = new RequestBuilder(rootUrl, personalSearchGeneratedNotes.PATH, 'post');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.query('search', params.search, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GeneratedNotePagedList>;
    })
  );
}

personalSearchGeneratedNotes.PATH = '/personalspace/notes-generated/search';
